import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@maui/elements'

export const DrawerBody = React.forwardRef((props, ref) => {
  return (
    <Box
      ref={ref}
      padding='spacePaddingXLarge'
      backgroundColor='colorBackgroundSurface'
      overflowY='auto'
      flex='1'
      {...props}
    />
  )
})

DrawerBody.displayName = 'DrawerBody'

DrawerBody.propTypes = {
  children: PropTypes.node,
}
